import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { CourseExperience } from './CourseOverview';

export default function MyCourses() {
  const { user } = useAuth();
  return <CourseExperience forcedCourseId={user?.courseId || ''} />;
}
